import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const Loading = ({ message, minHeight = '200px', fullScreen = false }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight={fullScreen ? '100vh' : minHeight}
      width="100%"
      gap={2}
    >
      <CircularProgress />
      {message && (
        <Typography variant="body1" color="textSecondary">
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default Loading;
